import { useEffect, useState, PropsWithChildren } from 'react';
import styles from './Sticky.module.css';
import classNames from 'classnames';
import { StickyOnScrollProps } from './Sticky.interfaces';

const DEFAULT_STIKY_POSITION = 5;
export const Sticky = ({
    children,
    elementRef,
}: PropsWithChildren<StickyOnScrollProps>) => {
    const [ elementPosition, setElementPosition ] = useState(Number.MAX_VALUE);

    useEffect(() => {
        const handleScroll = () => {
            const elementRec = elementRef?.current?.getBoundingClientRect();
            setElementPosition(elementRec?.bottom || Number.MAX_VALUE);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [ elementRef ]);
    return (
        <div
            role="region"
            tabIndex={ 0 }
            aria-label="Composant sticky en bas de la page"
            aria-hidden={ elementPosition >= DEFAULT_STIKY_POSITION }
            className={ classNames(styles.container, { [ styles.sticky ]: elementPosition < DEFAULT_STIKY_POSITION }) }
        >
            { children }
        </div>
    );
};
